import { Button, Paper, Stack } from "@mui/material";
import {
  Header,
  MUITable,
  useLanguageTranslator,
} from "../../../../../components";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { Filters } from "../../../filters";

function AdminModules({
  data,
  moduleKey,
  page,
  rowsPerPage,
  setRowsPerPage,
  setPage,
  onClickHandler,
  title,
  path = "",
  metadata = {},
  isView = false,
  isAccounts = false,
  tableColumns = [],
  children,
}: any) {
  const { translator } = useLanguageTranslator();

  const columns = [
    { id: "sr", label: "ID", minWidth: "100%", align: "left" },
    {
      id: "name",
      label: translator("dashboardTableHead.Name"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "createdAt",
      label: translator("dashboardTableHead.Date Created"),
      minWidth: "100%",
      align: "left",
    },
    {
      id: "updatedAt",
      label: translator("dashboardTableHead.Date Updated"),
      minWidth: "100px",
      align: "left",
    },
    {
      id: "id",
      label: translator("dashboardTableHead.Action"),
      minWidth: "100%",
      align: "right",
    },
  ];

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${title}.xlsx`);
  };
  return (
    <>
      <Header
        title={title}
        subtitle=""
      />
      <Stack direction={"row"} justifyContent={"space-between"} mx={3} mt={3}>
        <Link
          to={path}
          style={{
            backgroundColor: "#F6A000",
            padding: "8px 12px",
            color: "white",
            borderRadius: "10px",
            fontSize: "14px",
            marginTop: "12px",
            textDecoration: "none",
          }}
        >
          {translator("generic.Add New")}
        </Link>
        <Button
          onClick={handleDownloadExcel}
          sx={{
            backgroundColor: "#00AAB0",
            padding: "8px 12px",
            color: "white",
            borderRadius: "10px",
            fontSize: "14px",
            marginTop: "12px",
            textDecoration: "none",
          }}
        >
          {translator("Export Excel")}
        </Button>
      </Stack>
      {children}
      <Paper sx={{ margin: "20px 20px", background: "#ffffff" }}>
        <MUITable
          columns={isAccounts ? tableColumns : columns}
          data={data}
          moduleKey={moduleKey}
          onClickHandler={onClickHandler}
          totalPages={metadata?.totalPages}
          page={page}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          setPage={setPage}
          isView={isView}
        />
      </Paper>
    </>
  );
}

export { AdminModules };
